<template>
    <div
        class="table__actions position--relative display--flex"
        v-on="{
            ...( isInEditMode && {
                mouseover: () => show.tooltip = true,
                mouseleave: () => show.tooltip = false
            })
        }"
    >
        <button-with-icon
            v-if="$store.getters.can( settings.model, 'edit' ) && settings.active"
            :icon="{
                component: () => import( /* webpackChunkName: 'IconActive' */ '@/components/bundles/layout/images/icons/IconActive' ),
                class: 'svg'
            }"
            :class="[
                'table__actions__button',
                { 'disable': isInEditMode }
            ]"
            :aria-label="$t('accessibility.active')"
            :action="{
                execute: !isInEditMode,
                function: settings.active.action
            }"
        />
        <button-with-icon
            v-if="$store.getters.can( settings.model, 'delete' ) && settings.delete"
            :icon="{
                component: () => import( /* webpackChunkName: 'IconActive' */ '@/components/bundles/layout/images/icons/IconDelete' ),
                class: 'svg'
            }"
            :class="[
                'table__actions__button',
                { 'disable': isInEditMode }
            ]"
            :aria-label="$t('accessibility.delete')"
            :action="{
                execute: !isInEditMode,
                function: settings.delete.action
            }"
        />
        <slot name="custom__action" />
        <tooltip
            v-show="show.tooltip"
            class="table__actions__tooltip"
            direction="left"
            v-html="$t('global.exitEditMode')"
        />
    </div>
</template>

<script>
// packages
import { reactive, toRefs, computed } from '@vue/composition-api';
// store
import { useStore } from '@/hooks/use-store';

export default {
    components: {
        ButtonWithIcon: () => import( /* webpackChunkName: 'ButtonWithIcon' */ '@/components/bundles/buttons/BaseButtonWithIcon' ),
        Tooltip: () => import( /* webpackChunkName: 'Tooltips' */ '@/components/bundles/tooltips/Tooltip' )
    },
    props: {
        settings: {
            type: Object,
            default: () => ({ active: {}, disable: {}, delete: {} })
        }
    },
    setup () {
        // definição do state
        const state = reactive({
            show: { tooltip: false }
        });

        // obtenção dos getters da store
        const { getters } = useStore();

        // validação se esta no modo de edição ou não.
        const isInEditMode = computed( () => getters.isInEditMode );
        return { ...toRefs( state ), isInEditMode };
    }
};
</script>

<style lang="scss">
    .table {
        &__actions {
            gap: 10px;
            &__button {
                height: 26px;
            }
            &__tooltip {
                @include transform-position( 1px, false, false, -105px, translateX( -50% ) );
                width: max-content;
            }
        }
    }
</style>